import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
  const UTM_KEYS = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const
  const params = new URLSearchParams(window.location.search)

  UTM_KEYS.forEach((key) => {
    const val = params.get(key)
    if (val) sessionStorage.setItem(key, val)
  })
})
